/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx'
import {KTIcon} from '../../../helpers'
import Spinner from 'react-bootstrap/Spinner'

type Props = {
  className?: string
  svgIcon?: string
  titleClass?: string
  descriptionClass?: string
  iconClass?: string
  title?: string
  description?: string
  loading?: boolean
}

// const formattedJumlah
const TilesWidget5 = (props: Props) => {
  const {className, svgIcon, titleClass, descriptionClass, iconClass, title, description, loading} =
    props

  return (
    <div className={clsx('card', className)}>
      <div className='card-body d-flex flex-column justify-content-between'>
        <KTIcon iconName={svgIcon || ''} className={clsx(iconClass, 'fs-2hx ms-n1 flex-grow-1')} />

        <div className='d-flex flex-column'>
          <>
            {loading ? (
              <div className='d-flex align-items-center justify-content-center'>
                <Spinner animation='border' role='status' variant='light'>
                  <span className='visually-hidden'>Loading...</span>
                </Spinner>
              </div>
            ) : (
              <>
                <div className={clsx(titleClass, 'fw-bold fs-1 mb-0 mt-5')}>{title}</div>
                <div className={clsx(descriptionClass, 'fw-semibold fs-6')}>{description}</div>
              </>
            )}
          </>
        </div>
      </div>
    </div>
  )
}

export {TilesWidget5}
